import * as React from "react";
import { default as UserData, IUserInfo } from "../data/user";

interface IUserProps {
    data: UserData,
    handleError: (e: any) => void
}

interface IState {
    users: IUserInfo[]
}

export default class Users extends React.Component<IUserProps, IState> {
    public state: IState = { users: [] };

    private isActive = true;

    constructor(props: IUserProps) {
        super(props);
        this.props.data.GetAll()
            .then(d => d && this.isActive && this.setState({ users: d }))
            .catch(this.props.handleError);
    }

    public componentWillUnmount() {
        this.isActive = false;
    }

    public render() {
        return <div className="content">
            <h1>Brukere</h1>
            <div className="list">
                {
                    this.state.users.map(u =>
                        <div className="user" key={u.id}>
                            <div className="id">{u.id || "\u00A0"}</div>
                            <div className="name">{u.name || "\u00A0"}</div>
                            <div className="email">{u.email || "\u00A0"}</div>
                        </div>
                    )
                }
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/users/users.tsx